module.exports = __webpack_public_path__ + "static/media/checkin.44ce1d41.png";